<template>
    <div v-html="content_section">
        <!--section class="projects_area" id="dlealp_section_types">
            <div class="row m0">
                <div class="projects_item wd_18"> 
                    <img src="img/projects/divisorias.png" alt="">
                    <div class="hover">
                        <h4>Divisórias</h4>
                        <p>Atendendo o objetivo de separar ambientes, produzimos divisórias para escritórios, casas e quaisquer outros ambientes. Feitas com material de qualidade, acabamento impecável e simples instalação, elas não são apenas úteis, mas também decorativas.</p>
                    </div>
                </div>
                <div class="projects_item wd_18"> 
                    <img src="img/projects/forros.png" alt="">
                    <div class="hover">
                        <h4>Forros</h4>
                        <p>Beleza e funcionalidade! Os forros cobrem as imperfeições de telhados e lajes e ao menos tempo enfeitam o ambiente, deixando um ar de limpeza também. Forros evitam a entrada de insetos e a umidade excessiva.</p>
                    </div>
                </div>
                <div class="projects_item wd_44"> 
                    <img src="img/projects/hotelaria.png" alt="">
                    <div class="hover">
                        <h4>Hotelarias</h4>
                        <p>Execução de ambientes customizados, atendendo as novas tendências e utilizando tecnologia avançada para viabilizar a produção em massa sem perder o requinte.</p>
                    </div>
                </div>
                <div class="projects_item wd_18"> 
                    <img src="img/projects/marcenaria.png" alt="">
                    <div class="hover">
                        <h4>Marcenaria</h4>
                        <p>Soluções exclusivas e funcionais para cada ambiente de trabalho, criando uma atmosfera personalizada. Projetos de marcenaria executados seguindo conceitos e atuais de design e economia, atendendo as variadas necessidades do mercado.</p>
                    </div>
                </div>
            </div>
        </section -->
    </div>
</template>

<script>
    export default {
        name: 'Categories',
        props: {
            content_section: String,
        },
    }
</script>

<style>

</style>